import { useRecoilValue } from 'recoil';
import { rightSideBarFullState, rightSideBarTabState } from 'state/atoms';

const useRightSideBarFull = () => {
  const isFull = useRecoilValue(rightSideBarFullState);
  const isSelected = useRecoilValue(rightSideBarTabState);

  return {
    isFull,
    isFullAndSelected: Boolean(isFull && isSelected),
  };
};

export default useRightSideBarFull;
